import styled from 'styled-components'
import {device} from '../../media_queries'


const MainBanner = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 10vh;
  border-radius: 4px;
  z-index: 1;
  ${'' /* box-shadow: 0 2px 10px 0 rgba(0, 34, 91, 0.11); */}
  ${'' /* border: solid 1px #dfe8ee; */}
  background-color: #ffffff;

  @media ${device.mobileS} {
    padding-top: 10vh;
  }
  @media ${device.tablet} {
    padding-top: 5vh;
  }
  @media ${device.laptop} {
    padding-top: 10vh;
    width: 100%;
    height: 100%;
  }
  @media ${device.desktop} {
    padding-top: 10vh;
  }
`;

const BannerSec = styled.div`
    display: flex;
    width: 90vw;
    height: 70vh;;
    background-image: url('https://res.cloudinary.com/dojodevs/image/upload/v1581748045/smartia/RECURSOS/DashLap-05-05_ryccrf.png');
    background-position: center;
    background-size: cover;
    color: white;
    @media ${device.mobileS} {

}
    @media ${device.tablet} {
  
}
    @media ${device.laptop} {

}
    @media ${device.desktop} {
  
}
`
const BannerText = styled.div`
    color: #3b384b;
    width: 50vw;
    &>h2{
        font-size: 1em;
        font-family: 'panton-bold';
    }
    &>p {
        font-size: .5em;
        width: 80vw;
        font-family:'panton-light'
    }
    @media ${device.mobileS} {
    padding-top:5vh;
    font-size: 1em;
}&>p{
    padding: 2vw;
    margin-left:10vw;
    font-family: 'panton-bold';
    width: 65vw;
    font-size: .8em;
    color: white;
}
    @media ${device.tablet} {
    &>h2{
        font-size: 1.2em;
        width: 40vw;
        margin-left:50vw;
        color: white;
    }
    &>p{
        color: #3b384b;
        font-size: .8em;
        width:70%;
        margin-left: 1vw;
    }
}
    @media ${device.laptop} {
        &>h2{
        width: 40vw;
        font-size: 1.4em;
        margin-left:2vw;
        color: #3b384b;
    }
        &>p {
        width: 37vw;
        font-size: .8em;
    }
}
    @media ${device.desktop} {
        &>h2{
        width: 40vw;
        font-size: 1.4em;
        margin-left:5vw;
    }
        &>p {
        width: 40vw;
        font-size: 1.4em;
    }
  
}
`

export { MainBanner, BannerSec, BannerText};